import { NgModule } from '@angular/core';

import { FrontendGooglePlacesComponent } from './frontend-google-places.component';
import { NgMapsGoogleModule } from '@ng-maps/google';
import { NgMapsCoreModule } from '@ng-maps/core';
import { FrontendDropdownModule } from '@tablesready/frontend-dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    NgMapsCoreModule,
    NgMapsGoogleModule,
    FrontendDropdownModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [FrontendGooglePlacesComponent],
  exports: [
    FrontendGooglePlacesComponent,
  ],
})
export class FrontendGooglePlacesModule {}
